<script setup lang="ts">
import { ref, computed } from 'vue';

const showBadges = ref(false);

const badges = computed(() => {
  // @ts-ignore
  return window.$stores?.user?.state?.current?.metadata?.badges || [];
});
</script>

<template>
  <!-- Backdrop -->
  <div
    class="w-full h-full fixed top-0 left-0 z-40"
    @click="showBadges = false"
    v-if="showBadges"
  ></div>

  <!-- Panel principal -->
  <div
    class="fixed left-full z-50 w-[77vw] max-w-md h-[70vh] bottom-[18vh] transition-transform duration-300 ease-in-out"
    :class="{ 'translate-x-[-100%]': showBadges }"
  >
    <div
      class="bg-blue-600 shadow-2xl shadow-blue-600/30 border border-r-0 border-white w-full pr-1 rounded-l-4xl h-full relative flex flex-col"
    >
      <div class="overflow-y-auto h-full p-5 space-y-4 hide-scrollbar">
        <!-- En-tête -->
        <header class="mb-6 mt-2">
          <div class="flex items-center gap-3 mb-1">
            <h1 class="text-2xl font-bold text-white drop-shadow-xs">
              Mes Badges
            </h1>
          </div>
          <p class="text-xs text-blue-100 font-medium">
            Votre collection de trophées exclusifs
          </p>
        </header>

        <!-- Liste des Badges -->
        <div v-if="badges.length > 0" class="grid grid-cols-2 gap-4 pb-4">
          <div
            v-for="(badge, index) in badges"
            :key="index"
            class="bg-white/95 rounded-2xl p-4 flex flex-col items-center justify-center border-2 border-white shadow-lg transform transition-transform"
          >
            <div class="w-16 h-16 flex items-center justify-center mb-2">
              <ImgComponent :src="badge" class="w-full h-full object-contain drop-shadow-sm" />
            </div>
            <span class="text-[10px] font-bold text-slate-500 uppercase tracking-wider text-center">Récupéré</span>
          </div>
          <div
            v-for="(badge, index) in Array(10)"
            :key="index"
            class="bg-white/95 rounded-2xl p-4 flex flex-col items-center justify-center border-2 border-white shadow-lg transform transition-transform"
          >
            <div class="w-16 h-16 flex items-center justify-center mb-2 ">
              <ImgComponent src="/images/badge/badge.png" class="w-full h-full object-contain saturate-0 opacity-20 " />
            </div>
            <span class="text-[10px] font-bold text-slate-500 uppercase tracking-wider text-center">-</span>
          </div>
        </div>
        
        <!-- Empty state -->
        <div v-else class="bg-white/10 rounded-2xl p-6 text-center border-2 border-white/20 mt-8">
          <div class="text-5xl mb-3 opacity-50">🏆</div>
          <h3 class="text-white font-bold mb-2">Aucun badge</h3>
          <p class="text-blue-100 text-xs">Complétez des défis pour débloquer vos premiers badges !</p>
        </div>
      </div>
    </div>

    <!-- Bouton Toggle (Onglet latéral) -->
    <button
      @click="showBadges = !showBadges"
      class="w-16 h-16 -mr-[1px] rounded-l-full bg-blue-600 border border-white border-r-0 absolute right-full top-[calc(80%-5rem)] text-white flex justify-center items-center shadow-[-5px_0_15px_rgba(37,99,235,0.2)]"
      :class="{ 'border-transparent!': showBadges }"
    >
      <ColorImg
        src="/images/badge/badge-2.png"
        class="bg-white w-8 h-8"
        alt=""
      />
    </button>
  </div>
</template>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
